// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"VideoBlock_subtitle__2Kpf2","play-icon":"VideoBlock_play-icon__uZP36","description":"VideoBlock_description__2Ypw-"};